import { render, staticRenderFns } from "./JSelectTeacher.vue?vue&type=template&id=df74dd70&scoped=true"
import script from "./JSelectTeacher.vue?vue&type=script&lang=js"
export * from "./JSelectTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df74dd70",
  null
  
)

export default component.exports